import { render, staticRenderFns } from "./IntelligentBookingResultMulti.vue?vue&type=template&id=644a0578&"
import script from "./IntelligentBookingResultMulti.vue?vue&type=script&lang=js&"
export * from "./IntelligentBookingResultMulti.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentBookingResultMulti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644a0578')) {
      api.createRecord('644a0578', component.options)
    } else {
      api.reload('644a0578', component.options)
    }
    module.hot.accept("./IntelligentBookingResultMulti.vue?vue&type=template&id=644a0578&", function () {
      api.rerender('644a0578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/IntelligentBookingResultMulti.vue"
export default component.exports